import React, { Component } from 'react';
import 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.css';
import { compose } from 'redux';
import { connect } from 'react-redux';

import galleryOpenImage from '../../images/gallery-open.svg';
import {inIframe, postMessageToParent} from "../../utils";

class RoomOfferGallery extends Component {

	initLightGallery = ref => {
		this.lightGallery = ref;

		if (inIframe()) {
			postMessageToParent('loadLightGallery', {
				id: this.props.roomOffer.id,
				photos: this.props.roomOffer.photos.map(photo => window.location.origin + photo.original)
			});
		} else {
			window.lightGallery(ref, {
				download: false
			});
		}
	};

	componentWillUnmount() {
		if (inIframe()) {
			postMessageToParent('unloadLightGallery', { id: this.props.roomOffer.id });
		} else {
			// Unmount lightgallery.js
			if (this.lightGallery && this.lightGallery.getAttribute('lg-uid') && window.lgData) {
				window.lgData[this.lightGallery.getAttribute('lg-uid')].destroy();
			}
		}
	}

	onClick = (e, index) => {
		if (inIframe()) {
			e.preventDefault();
			postMessageToParent('openLightGallery', { id: this.props.roomOffer.id, index: index });
		}
	};

	render() {
		const { roomOffer, apiOrigin } = this.props;

		return (
			<div className="room-offer__gallery" ref={ this.initLightGallery }>
				{roomOffer.photos.map((photo, index) => (
					<a
						href={apiOrigin + photo.large}
						className={`${index >= 5 ? 'hidden' : ''} room-offer__photo-container`}
						key={index}
						onClick={e => this.onClick(e, index)}
					>
						{index < 5 &&
						<React.Fragment>
							<div
								className="room-offer__photo"
								style={{backgroundImage: `url(${apiOrigin}${photo.medium})`}}
							/>
							{index === 0 &&
							<img src={galleryOpenImage} alt="" className="room-offer__photo-gallery-open"/>
							}
						</React.Fragment>
						}
					</a>
				))}
			</div>
		);
	}
}

export default compose(
	connect((state) => ({
		apiOrigin: state.app.apiOrigin,
	})),
)(RoomOfferGallery);



// WEBPACK FOOTER //
// ./src/components/Rooms/RoomOfferGallery.jsx